import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

// Processes Emergent OAuth session_id from URL fragment, exchanges for cookie, redirects.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { processSessionId } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    processSessionId(sessionId)
      .then((user) => {
        // Clear hash and redirect
        window.history.replaceState(null, "", "/dashboard");
        toast.success(`Welcome, ${user.name}!`);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [navigate, processSessionId]);

  return (
    <div className="container-wide py-24">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#737373]">
        Signing you in…
      </p>
      <div className="mt-4 h-4 w-48 bg-[#F5F5F5] animate-pulse" />
    </div>
  );
}
